export default "/images/12 Step2Plan-Consultant-To view goals and action plans-01.png?8a7b14ff093e42725649fc18ed7f353a";